const log = (args) => {
  if (process.env.CONSOLE_LOG) {
    // eslint-disable-next-line no-console
    console.log(args);
  }
};

export default log;
